
<ng-container *ngIf="initialized">
    <p-menu [model]="navigationEntriesMenu" styleClass="w-full overflow-y-scroll max-h-page"></p-menu>
</ng-container>


